import React, { Component } from 'react';
import homedata from '../../data/homedata.json';

class Contact extends Component {
  state = {
    dropdownOpen: false,
    selectedService: "Select Service"
  };

  toggleDropdown = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  selectService = (service) => {
    this.setState({
      selectedService: service,
      dropdownOpen: false
    });
  };

  render() {
    return (
      <section id="contact" className="p-80px-tb">
        <div className="container">

          <div className="row">
            <div className="col-sm-8 offset-sm-2">
              <div className="section-title text-center m-50px-b">
                <h2>{homedata.contact.title}</h2>
              </div>
            </div>
          </div>

          <div className="row row-eq-height">

            {/* ✅ LEFT SIDE (SVG ICONS) */}
           <div className="col-lg-4 col-md-6 contact-address p-30px">

  <div className="address-box text-center p-15px m-15px-b">
    <div className="icon-svg">📍</div>
    <h5>{homedata.contact.contactinfo.address.title}</h5>
    <p>
      <a
        href="https://www.google.com/maps?q=Prasad+Hospitals+Marrichettu+Road+Manikonda+Hyderabad"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "inherit", textDecoration: "inherit" }}
      >
        {homedata.contact.contactinfo.address.info}
      </a>
    </p>
  </div>

  <div className="address-box text-center p-15px m-15px-b">
    <div className="icon-svg">📞</div>
    <h5>{homedata.contact.contactinfo.phone.title}</h5>
    <p>
      <a
        href="tel:+917799140788"
        style={{ color: "inherit", textDecoration: "inherit" }}
      >
        {homedata.contact.contactinfo.phone.info}
      </a>
    </p>
  </div>

  <div className="address-box text-center p-15px">
    <div className="icon-svg">✉️</div>
    <h5>{homedata.contact.contactinfo.email.title}</h5>
    <p>
      <a
        href="mailto:admin@ikigaihospitals.com"
        style={{ color: "inherit", textDecoration: "inherit" }}
      >
        {homedata.contact.contactinfo.email.info}
      </a>
    </p>
  </div>

</div>

            {/* RIGHT SIDE FORM */}
            <div className="col-lg-8 col-md-6 contact-form p-30px">
              <h3 className="m-25px-b">{homedata.contact.formtitle}</h3>
              <p className="m-25px-b">{homedata.contact.formdescription}</p>

              <form>

                <div className="row">

                  <div className="col-md-6 mb13">
                    <input type="text" placeholder="Full Name" required />
                  </div>

                  <div className="col-md-6 mb13">
                    <input type="email" placeholder="Email Address" required />
                  </div>

                  <div className="col-md-6 mb13">
                    <input type="tel" placeholder="Mobile Number" required />
                  </div>

                  <div className="col-md-6 mb13">
                    <input type="text" placeholder="Address" />
                  </div>

                  {/* CUSTOM DROPDOWN */}
                  <div className="col-md-6 mb13">
                    <div className="custom-dropdown">
                      <div
                        className="dropdown-selected"
                        onClick={this.toggleDropdown}
                      >
                        {this.state.selectedService}
                      </div>

                      {this.state.dropdownOpen && (
                        <div className="dropdown-options">
                          {homedata.contact.services.map((service, i) => (
                            <div
                              key={i}
                              className="dropdown-item"
                              onClick={() => this.selectService(service)}
                            >
                              {service}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-3 mb13">
                    <input type="date" required />
                  </div>

                  <div className="col-md-3 mb13">
                    <input type="time" required />
                  </div>

                  <div className="col-md-12 mb30">
                    <textarea placeholder="Your Message"></textarea>
                  </div>

                  <div className="col-md-12">
                    <button className="btn btn-default btn-filled">
                      Book Appointment
                    </button>
                  </div>

                </div>

              </form>
            </div>

          </div>
        </div>
      </section>
    );
  }
}

export default Contact;